import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserIdService {

  private readonly STORAGE_KEY = 'browser_id';

  constructor() {}

  getBrowserId(): string {
    let id = localStorage.getItem(this.STORAGE_KEY);
    console.info('getBrowserId ', id)
    if (!id) {
      id = this.generateBrowserId();
      localStorage.setItem(this.STORAGE_KEY, id);
      console.info('id not found set new one ', id);
    }

    return id;
  }

  private generateBrowserId(): string {
    console.info('generateBrowserId called')
    return crypto.randomUUID();
  }
}
